module.exports = __webpack_public_path__ + "img/运营活动-灰.9372baae.png";